export function trimFieldString(f) {
  return f.replace(/^"/gi, "").replace(/"$/gi, "")
}

export function has_column(source, name) {
  return has_rc(source, name, "column")
}

export function has_row(source, name) {
  return has_rc(source, name, "row")
}

export function has_rc(source, name, ax) {
  if (source?.layout?.[ax] !== undefined) {
    for (let axi of source.layout[ax]) {
      if (axi === name) return true;
      else if (axi?.field === name) return true;
      else if (axi?.[0]?.field === name) return true
    }
    return false;
  }
  else return true;
}

export function search_asp(parsed, line, searchby) {
  if (!searchby) return parsed?.entire?.filter(d => d.asp.trim() === line)
  else if (searchby === "startsWith") return parsed?.entire?.filter(d => d.asp.trim().startsWith(line))
  else return [];
}

export function deepcopy(o) {
  return JSON.parse(JSON.stringify(o));
}

export function unique(a) {
  return Array.from(new Set(a));
}

export function arrayIdentity(arr, brr) {
  if (arr.length !== brr.length) return false;
  else {
    for (const i in arr) {
      if (arr[i] != brr[i]) return false;
    }
    return true;
  }
}

export function parseColor(c) {
  if (c == undefined) return null;
  else if (c.r !== undefined && c.g !== undefined && c.b !== undefined) return c;
  else if (c.startsWith("#")) return parseHexColor(c);
  else if (c.startsWith("rgba(")) return parseRGBA(c);
  return;
}

let hexRegex = /^\#[0-9A-Fa-f]{6}$/;
export function parseHexColor(hex) {
  if (hex == null) {
    return null
  } else if (hex.constructor.name === "String" && hex.match(hexRegex) != null) {
    let _rgba = hex.replace("#", "");
    let r = parseInt(_rgba.substring(0, 2), 16);
    let g = parseInt(_rgba.substring(2, 4), 16);
    let b = parseInt(_rgba.substring(4, 6), 16);
    return { r, g, b, a: 1 };
  }
}
let rgbaRegex = /^rgba\(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-5][0-9])\,([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-5][0-9])\,([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-5][0-9])\,([01](\.[0-9]+)?)\)$/;
export function parseRGBA(rgba) {
  if (rgba == null) {
    return null
  } else if (rgba.constructor.name === "String" && rgba.match(rgbaRegex) != null) {
    let _rgba = rgba.replace(/^rgba\(/, "").replace(/\)$/, "").split(",");
    let [r, g, b, a] = _rgba.map((d, i) => (i < 3 ? parseInt(d) : parseFloat(d)));
    return { r, g, b, a };
  }
  return null;
}
export function encodeRGBhex(rgba) {
  if (rgba.constructor.name === "Object") {
    let r = rgba.r.toString(16);
    let g = rgba.g.toString(16);
    let b = rgba.b.toString(16);
    return `#${r.length == 1 ? "0" + r : r}${g.length == 1 ? "0" + g : g}${b.length == 1 ? "0" + b : b}`;
  } else return "#000000";
}
export function makeRGBAString(r, g, b, a) {
  return `rgba(${r},${g},${b},${a})`;
}

export function getComplementaryColor(c, f) {
  let hex = "#" + (0xffffff ^ parseInt(encodeRGBhex(parseColor(c)).replace("#", ""), 16)).toString(16);
  if (f === "rgba") {
    let co = parseHexColor(hex);
    return makeRGBAString(co.r, co.g, co.b, co.a);
  } else {
    return hex;
  }
}

export function adjustColorLightness(rgba, rate) {
  if (rate === undefined) rate = 0.5;

  function adjust(v, r) {
    return capInRange(Math.round(255 * (v / 255 + r)), 0, 255);
  }
  let p = parseColor(rgba);
  // let hsl = convertRGBtohSL(p);
  // hsl.l = Math.max(Math.min(hsl.l * (1 + rate), 1), 0);
  // hsl.s = Math.max(Math.min(hsl.s * (1 + rate), 1), 0);
  // let p2 = convertHSLtoRGB(hsl);
  let p2 = {
    r: adjust(p.r, rate),
    g: adjust(p.g, rate),
    b: adjust(p.b, rate),
    a: p.a
  }
  return makeRGBAString(p2.r, p2.g, p2.b, p2.a);
}

function capInRange(v, min, max) {
  return Math.max(Math.min(v, max), min);
}

function convertRGBtohSL(rgb) {
  let r = rgb.r, g = rgb.g, b = rgb.b
  let MX = Math.max(r, b, g), MN = Math.min(r, g, b);
  let d = (MX - MN) / 255;
  let l = (MX + MN) / 510;
  let s = l > 0 ? d / (1 - Math.abs(2 * l - 1)) : 0;
  let cd = (r - g / 2 - b / 2) / Math.sqrt(r * r + g * g + b * b - r * g - r * b - g * b);
  let cos = Math.acos(cd) * (180 / Math.PI);
  let h = g >= b ? cos : 360 - cos;
  return { h, s, l };
}

function convertHSLtoRGB(hsl) {
  let h = hsl.h, s = hsl.s, l = hsl.l;
  let d = s * (1 - Math.abs(2 * l - 1));
  let m = 255 * (l - d / 2);
  let x = d * (1 - Math.abs((h / 60) % 2 - 1));
  let r, g, b;
  if (0 <= h && h <= 60) {
    r = Math.round(255 * d + m);
    g = Math.round(255 * x + m);
    b = Math.round(m);
  } else if (60 <= h & h <= 120) {
    r = Math.round(255 * x + m);
    g = Math.round(255 * d + m);
    b = Math.round(m);
  } else if (120 <= h & h <= 180) {
    r = Math.round(m);
    g = Math.round(255 * d + m);
    b = Math.round(255 * x + m);
  } else if (180 <= h & h <= 240) {
    r = Math.round(m);
    g = Math.round(255 * x + m);
    b = Math.round(255 * d + m);
  } else if (240 <= h & h <= 300) {
    r = Math.round(255 * x + m);
    g = Math.round(m);
    b = Math.round(255 * d + m);
  } else if (300 <= h & h <= 360) {
    r = Math.round(255 * d + m);
    g = Math.round(m);
    b = Math.round(255 * x + m);
  }
  return { r, g, b };
}

export function makeGradient(key) {
  let rgba = parseColor(key);
  let out = {
    a: rgba.a
  };
  ['r', 'g', 'b'].forEach((c) => {
    out[c] = Math.round(rgba[c] + (1 - rgba[c] / 255) * 225)
  });
  return [makeRGBAString(out.r, out.g, out.b, out.a), makeRGBAString(rgba.r, rgba.g, rgba.b, rgba.a)];
}

export function arrayMode(arr) {
  let count = {}, max = 0, argMax;
  for (const a of arr) {
    if (!count[a]) count[a] = 0;
    count[a] += 1;
    if (max < count[a]) {
      max = count[a];
      argMax = a;
    }
  }
  return argMax
}

export function arrayCount(arr) {
  let count = {};
  for (const a of arr) {
    if (!count[a]) count[a] = 0;
    count[a] += 1;
  }
  return count
}

// letter width setup
const letterWidth = {
  // scaled at font height 12px
  "0": 7.23,
  "1": 7.23,
  "2": 7.23,
  "3": 7.23,
  "4": 7.23,
  "5": 7.23,
  "6": 7.23,
  "7": 7.23,
  "8": 7.23,
  "9": 7.23,
  "a": 7.23,
  "b": 7.23,
  "c": 6.5,
  "d": 7.23,
  "e": 7.23,
  "f": 3.63,
  "g": 7.23,
  "h": 7.23,
  "i": 2.89,
  "j": 2.89,
  "k": 6.5,
  "l": 2.89,
  "m": 10.84,
  "n": 7.23,
  "o": 7.23,
  "p": 7.23,
  "q": 7.23,
  "r": 4.34,
  "s": 6.5,
  "t": 3.63,
  "u": 7.23,
  "v": 6.5,
  "w": 9.39,
  "x": 6.5,
  "y": 6.5,
  "z": 6.5,
  ".": 3.63,
  ",": 3.63,
  ";": 3.63,
  ":": 3.63,
  "A": 8.67,
  "B": 8.67,
  "C": 9.39,
  "D": 9.39,
  "E": 8.67,
  "F": 7.95,
  "G": 10.13,
  "H": 9.39,
  "I": 3.63,
  "J": 6.5,
  "K": 8.67,
  "L": 7.23,
  "M": 10.84,
  "N": 9.39,
  "O": 10.13,
  "P": 8.67,
  "Q": 10.13,
  "R": 9.39,
  "S": 8.67,
  "T": 7.95,
  "U": 9.39,
  "V": 8.67,
  "W": 12.28,
  "X": 8.67,
  "Y": 8.67,
  "Z": 7.95,
  "!": 3.63,
  "@": 13.2,
  "#": 7.23,
  "$": 7.23,
  "%": 11.56,
  "^": 6.11,
  "&": 8.67,
  "*": 5.06,
  "(": 4.34,
  ")": 4.34,
  "_": 7.23,
  "-": 4.34,
  "+": 7.59,
  "=": 7.59,
  "\"": 4.63,
  "“": 4.63,
  "”": 4.63,
  "'": 2.48,
  "’": 2.48,
  "‘": 2.48,
  "<": 7.59,
  ">": 7.59,
  "?": 7.23,
  "/": 3.63,
  "|": 3.39,
  "~": 7.59,
  "`": 4.34,
  " ": 3.63,
  others: 9
};
export function getDefaultBoxWidth(text, height) {
  if (text !== undefined) {
    let textRows = text.split(/\<br\/+\>/g);
    textRows = textRows.map(row => { return row.replace(/\<\/?[^\>]+\>/g, "") });
    let rowWidths = textRows.map((row) => {
      let textSplit = row.replace(/(\<.+\"\>)/g, "").split("");
      return textSplit.map((d) => (letterWidth[d] ? letterWidth[d] : letterWidth.others)).reduce((a, d) => a + d, 0) * height / 12;
    });
    return Math.max(...rowWidths);
  } else {
    return 0;
  }
}